var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageParserOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "92px",
    viewBox: "0 0 88 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(-11.000000, -100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,33.5 L17.5,33.5",
    id: "Line-6",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,48.5 L17.5,33.5",
    id: "Line-6",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,48.5 L27,48.5",
    id: "Line-6",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,60.5 L47,54.5",
    id: "Line-6-Copy",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,79.5 L47,73.5",
    id: "Line-6-Copy",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,8.5 L26.5,8.5",
    id: "Line-3",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 27.5,
    y: 2.5,
    width: 42,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "User-Input",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36,
    y: 10
  }, "User Input")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 27.5,
    y: 27.5,
    width: 42,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 27.5,
    y: 42.5,
    width: 42,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "MessageParser",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 35
  }, "MessageParser")), /*#__PURE__*/React.createElement("text", {
    id: "parse(message)",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 50
  }, "parse(message)")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 20.5,
    y: 61.5,
    width: 59,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "#386C7E",
    fillRule: "nonzero",
    x: 27.5,
    y: 79.5,
    width: 42,
    height: 12,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Custom-parse-logic",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 28,
    y: 69
  }, "Custom parse logic")), /*#__PURE__*/React.createElement("text", {
    id: "Action",
    fontFamily: "NeutrifPro-Medium, Neutrif Pro",
    fontSize: 5,
    fontWeight: 400,
    fill: "#585858"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 87
  }, "Action")), /*#__PURE__*/React.createElement("path", {
    d: "M70,8 L87.5,8",
    id: "Line-4",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,33.5 L87.5,8",
    id: "Line-4",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#386C7E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Line-5",
    d: "M75.2222222,33.4 L87.5,33.4 L87.6,33.4 L87.6,33.6 L87.5,33.6 L75.2222222,33.6 L75.2222222,36 L70.2222222,33.5 L75.2222222,31 L75.2222222,33.4 Z",
    fill: "#386C7E",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,33.5 L75,33.5",
    id: "Line-4",
    stroke: "#386C7E",
    strokeLinecap: "square",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-alt",
    transform: "translate(5.000000, 4.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.86666667,4.53333333 C5.11805556,4.53333333 6.13333333,3.51805556 6.13333333,2.26666667 C6.13333333,1.01527778 5.11805556,0 3.86666667,0 C2.61527778,0 1.6,1.01527778 1.6,2.26666667 C1.6,3.51805556 2.61527778,4.53333333 3.86666667,4.53333333 Z M6,5.06666667 L5.1390625,5.06666667 C4.7921875,5.2225 4.40625,5.31111111 4,5.31111111 C3.59375,5.31111111 3.209375,5.2225 2.8609375,5.06666667 L2,5.06666667 C0.8953125,5.06666667 0,5.94208333 0,7.02222222 L0,7.26666667 C0,7.67152778 0.3359375,8 0.75,8 L7.25,8 C7.6640625,8 8,7.67152778 8,7.26666667 L8,7.02222222 C8,5.94208333 7.1046875,5.06666667 6,5.06666667 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageParserOverview);
export default __webpack_public_path__ + "static/media/message-parser-overview.37ad9769442a0961141deb99c386e182.svg";
export { ForwardRef as ReactComponent };